<template>
  <m-dialog :action="false" :title="getDeepObj(detail, 'kuesioner.nama')" ref="dialog" :fullscreen="false" :btnsave="false" bgColor="#f6f5f5">
    <v-container class="pa-5">
      <template v-if="isReady && !Object.keys(detail).length">
        <v-card class="pa-3">
          <v-card-text class="text-center">
            <v-avatar size="40" color="red">
              <v-icon size="30" color="white">mdi-close</v-icon>
            </v-avatar>
            <div class="subtitle-1 mt-5 font-weight-regular black--text">Mohon Maaf</div>
            <div>Kuesioner tidak tersedia untuk saat ini</div>
          </v-card-text>
        </v-card>
      </template>
      <preview
        v-else-if="Object.keys(detail).length"
        ref="survey"
        :surveys="surveys"
        :isMobile="true"
        :isReadInfo="detail.is_edit"
        :isReadonly="!detail.is_edit"
        :useStep="false"
        :useSave="detail.is_edit"
        :info="info"
        @answer="handleAnswer"
        @save="onSave"
      />
    </v-container>
  </m-dialog>
</template>
<script>
import Preview from '@/modules/kuesioner/components/Preview.vue'
export default {
  components: { Preview },
  computed: {
    surveys() {
      let soals = (this.detail && this.detail.soals) || []
      let items = []
      soals.forEach((item) => {
        let result = null
        let catatan = null

        if (item.k_tipe_soal === 2) {
          result = []
          catatan = ''
          const jawaban = this.getDeepObj(item, 'kuesioner_jawabans') || []
          jawaban.forEach((val) => {
            result.push(val.teks)
          })
          const lainnya = jawaban.find((s) => s.teks === 'Lainnya...') || {}
          if (Object.keys(lainnya).length) {
            catatan = lainnya.catatan || ''
          }
        } else {
          result = ''
          catatan = ''
          const jawaban = this.getDeepObj(item, 'kuesioner_jawabans') || []
          if (jawaban.length > 0) {
            result = this.getDeepObj(jawaban, '0.teks')
            catatan = this.getDeepObj(jawaban, '0.catatan')
          }
        }

        let obj = {
          kuesioner_soal_id: item.kuesioner_soal_id,
          label: item.label,
          k_tipe_soal: item.k_tipe_soal,
          is_required: item.is_required,
          opsi: item.kuesioner_opsis || [],
          result: result,
          catatan: catatan,
        }

        items.push()

        if ([4, 5].includes(Number(item.k_tipe_soal))) {
          this.$set(obj, 'text', result)
        }

        items.push(obj)
      })

      return items || []
    },
    info() {
      return Object.assign(
        {},
        this.getDeepObj(this.detail, 'kuesioner') || {},
        { is_wizard: 0 },
        { user: this.getDeepObj(this.detail, 'user') || {} },
        { organisasi: this.getDeepObj(this.detail, 'organisasi') || {} }
      )
    },
  },
  data() {
    return {
      isReady: false,
      detail: {},
    }
  },
  methods: {
    open(obj) {
      this.$refs.dialog.open()
      this.detail = obj
      this.isReady = true
    },

    handleAnswer(item) {
      if (!this.isReady) return
      let params = {}
      let soals = []

      let result = typeof item.result === 'object' ? item.result : [item.result]

      result.forEach((val) => {
        let soal = {}
        this.$set(soal, 'kuesioner_soal_id', item.kuesioner_soal_id)
        this.$set(soal, 'teks', item.text)
        if (item.k_tipe_soal < 4) {
          const opsi = (item.opsi || []).find((s) => s.label === val) || {}
          if (Object.keys(opsi).length) {
            this.$set(soal, 'kuesioner_opsi_id', opsi.kuesioner_opsi_id)
            this.$set(soal, 'urutan', this.getDeepObj(opsi, 'urutan'))
          }
          this.$set(soal, 'teks', val)
          if (this.getDeepObj(item, 'catatan') && val === 'Lainnya...') this.$set(soal, 'catatan', item.catatan)
        } else {
          if (this.getDeepObj(item, 'catatan')) this.$set(soal, 'catatan', item.catatan)
        }

        soals.push(soal)
      })

      params = Object.assign(
        {},
        { k_tipe_soal: item.k_tipe_soal, kuesioner_soal_id: item.kuesioner_soal_id, soal: soals }
      )

      this.$store.commit('main/setAutoSave', true)
      this.$store.dispatch('kuesioner/setJawabanUser', {
        params,
        organisasi_id: this.organisasi_id,
        kuesioner_id: this.detail.id,
      })
    },
    onSave(items) {
      const soals = []
      items.forEach((item) => {
        if (item.k_tipe_soal === 2) {
          const res = item.result || []
          res.forEach((val) => {
            let params = {}
            this.$set(params, 'kuesioner_soal_id', item.kuesioner_soal_id)
            this.$set(params, 'teks', val)
            if (item.k_tipe_soal < 4) {
              const opsi = (item.opsi || []).find((s) => s.label === val) || {}
              if (Object.keys(opsi).length) {
                this.$set(params, 'kuesioner_opsi_id', opsi.kuesioner_opsi_id)
                this.$set(params, 'urutan', this.getDeepObj(opsi, 'urutan'))
              }
              this.$set(params, 'teks', val)
              if (this.getDeepObj(item, 'catatan') && val === 'Lainnya...') this.$set(params, 'catatan', item.catatan)
            } else {
              if (this.getDeepObj(item, 'catatan')) this.$set(params, 'catatan', item.catatan)
            }

            soals.push(params)
          })
        } else {
          let params = {}
          this.$set(params, 'kuesioner_soal_id', item.kuesioner_soal_id)
          this.$set(params, 'teks', item.text)
          if (item.k_tipe_soal < 4) {
            const opsi = (item.opsi || []).find((s) => s.label === item.result) || {}
            if (Object.keys(opsi).length) {
              this.$set(params, 'kuesioner_opsi_id', opsi.kuesioner_opsi_id)
              this.$set(params, 'urutan', this.getDeepObj(opsi, 'urutan'))
            }
            this.$set(params, 'teks', item.result)
          }

          if (this.getDeepObj(item, 'catatan')) this.$set(params, 'catatan', item.catatan)
          soals.push(params)
        }
      })

      this.$refs.survey.isLoading = true
      this.$store.commit('main/setAutoSave', false)
      this.$store
        .dispatch('kuesioner/setJawabanLengkapUser', {
          params: { soal: soals },
          kuesioner_id: this.detail.id,
          organisasi_id: this.organisasi_id,
        })
        .then(() => {
          this.$success('Jawaban berhasil disimpan')
          this.$emit('reload')
          this.$refs.dialog.reject()
          this.$refs.survey.isLoading = false
        }).catch(() => {
          this.$refs.survey.isLoading = false
      })
    },
  },
  destroyed() {
    this.$store.commit('main/setAutoSave', false)
  }
}
</script>
